import { render, staticRenderFns } from "./PassengerInput.vue?vue&type=template&id=648000f5&"
import script from "./PassengerInput.vue?vue&type=script&lang=js&"
export * from "./PassengerInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports